import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ersatz für focusRenderedView() aus src/accessibility.js. Dort wurde der Fokus
 * auf #main-content verschoben, wenn sich ein zusammengesetzter "View-Key" (View +
 * Step + Submodul + Video + Modal-Flags) änderte. Mit echtem Routing entspricht
 * das genau einem Pfadwechsel; offene Radix-Dialoge (role=dialog/alertdialog)
 * übernehmen ihren Fokus selbst und werden hier ausgespart.
 */
export function useFocusMain() {
  const location = useLocation();

  useEffect(() => {
    if (document.querySelector('[role="dialog"], [role="alertdialog"]')) return;
    const main = document.getElementById("main-content");
    if (!main) return;
    const frame = requestAnimationFrame(() => {
      main.focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(frame);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
